import { render, staticRenderFns } from "./ModalCustomerSegment.vue?vue&type=template&id=0d5653e1"
import script from "./ModalCustomerSegment.vue?vue&type=script&lang=js"
export * from "./ModalCustomerSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports